













































































































































































import {Component, Mixins} from 'vue-property-decorator';
import JudgementListMethodsMixin from '@/components/product/judgement/JudgementListMethodsMixin';
import JudgementListSummary from '@/components/product/judgement/JudgementListSummary.vue';
import JudgementListContent from '@/components/product/judgement/JudgementListContent.vue';
import JudgementListSlotLeft from '@/components/product/judgement/JudgementListSlotLeft.vue';
import JudgementListSlotRight from '@/components/product/judgement/JudgementListSlotRight.vue';
import JudgementListSearchMenu from '@/components/product/judgement/JudgementListSearchMenu.vue';
import JudgementListBottomContent from '@/components/product/judgement/JudgementListBottomContent.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import PageDateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';
import PageSizeData from '@/components/board/mixins/PageSizeData';

@Component({
  components: {
    JudgementListContent,
    JudgementListSummary,
    JudgementListSlotLeft,
    JudgementListSlotRight,
    JudgementListSearchMenu,
    JudgementListBottomContent,
    PageTitle,
    PageFormBtn,
    PageFormSelect,
    PageDateRangePicker,
    PageDateFilterBtns,
    PageSizeData
  }
})
export default class JudgementList extends Mixins(JudgementListMethodsMixin, PageSizeData) {}
